import { ReactNode } from 'react'
import { Box, Button, Stack } from '@mui/material'
import { SearchWordField } from 'components/controls/searchWordField'
import { PlusIcon } from 'shared/icons'

type ConfigureListHeaderProps = {
  openAddButtonLabel?: string
  openAddDialog?: () => void
  searchWord?: string
  setSearchWord?: (word: string) => void,
  filters?: ReactNode
  children?: ReactNode
}
export const ConfigureListHeader = ({
  openAddButtonLabel,
  openAddDialog,
  searchWord,
  setSearchWord,
  filters,
  children
}: ConfigureListHeaderProps) => {
  return (
    <Stack direction="row" padding={2} spacing={1} alignItems="center">
      {openAddDialog && (
        <Stack flexGrow={1} direction="row" spacing={1}>
          <Button
            startIcon={<PlusIcon />}
            variant="contained"
            size="large"
            onClick={openAddDialog}
          >
            {openAddButtonLabel ?? "追加"}
          </Button>
        </Stack>
      )}
      <Box flexGrow={1}>
        {children}
      </Box>
      <Stack flexShrink={0} direction="row" spacing={1}>
        {filters}
        {setSearchWord !== undefined && searchWord !== undefined && (
          <SearchWordField
            id="configure-list-searchword"
            searchWord={searchWord}
            onChangeSearchWord={setSearchWord}
          />
        )}
      </Stack>
    </Stack>
  )
}
